import { render, staticRenderFns } from "./veRingL.vue?vue&type=template&id=2b35a7de&"
import script from "./veRingL.vue?vue&type=script&lang=js&"
export * from "./veRingL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports